export default "__VITE_ASSET__Cx8SEWP3__"